import 'reflect-metadata';
import { snakeCase } from 'lodash-es';
import { BaseEntityDescriptor, } from '../../core/BaseEntityDescriptor.js';
import { TRANSPORT } from '../../service/enums.js';
import { pascalCase } from '../../utils/strings.js';
const ENUM_METADATA_KEY = Symbol('enum:data');
class EnumDescriptor extends BaseEntityDescriptor {
    enumSrc;
    prefix;
    validProtoMapping;
    reverseRecordMapping;
    constructor(enumSrc, name) {
        super(name);
        this.enumSrc = enumSrc;
        this.prefix = `${snakeCase(this.name).toUpperCase()}__`;
        const { validProtoMapping, reverseRecordMapping } = this.initMappings();
        this.validProtoMapping = validProtoMapping;
        this.reverseRecordMapping = reverseRecordMapping;
    }
    keyToProto(key) {
        return this.prefix + snakeCase(key).toUpperCase();
    }
    getExample(transport) {
        const firstKey = Object.keys(this.enumSrc)[0];
        if (transport === TRANSPORT.GRPC) {
            return this.keyToProto(firstKey);
        }
        else {
            return this.enumSrc[firstKey];
        }
    }
    toProto(idMappings) {
        const name = pascalCase(this.name);
        const mapping = idMappings[name] || { __type: 'enum', __next: 0 };
        const keys = ['INVALID', ...Object.keys(this.enumSrc)].map((key) => `  ${this.keyToProto(key)} = ${(mapping[snakeCase(key)] =
            mapping[snakeCase(key)] ?? mapping.__next++)};`);
        idMappings[name] = mapping;
        return {
            proto: {
                comments: [],
                definition: ['', `enum ${name} {`, ...keys, '}'],
            },
            references: [],
        };
    }
    toSchema(transport) {
        let values;
        if (transport === TRANSPORT.GRPC) {
            values = [...Object.keys(this.enumSrc)].map((key) => this.keyToProto(key));
        }
        else {
            values = Object.values(this.enumSrc);
        }
        return {
            references: [],
            schema: {
                enum: values,
                example: values[0],
            },
        };
    }
    initMappings() {
        const validProtoMapping = {};
        const reverseRecordMapping = {};
        Object.entries(this.enumSrc).forEach(([key, value]) => {
            validProtoMapping[this.keyToProto(key)] = value;
            reverseRecordMapping[value] = key;
        });
        return { validProtoMapping, reverseRecordMapping };
    }
    fromJSON(value) {
        const key = this.reverseRecordMapping[value];
        if (!key) {
            throw new Error(`The value '${value}' does not exist in ${this.name}!`);
        }
        return value;
    }
    fromProto(protoKey) {
        const res = this.validProtoMapping[protoKey];
        if (!res) {
            throw new Error(`The key '${protoKey}' does not exist in 'validProtoMapping' for ${this.name}!`);
        }
        return res;
    }
    keyFromValue(value, transport) {
        const res = this.reverseRecordMapping[value];
        if (!res) {
            return undefined;
        }
        if (transport === TRANSPORT.GRPC) {
            return this.keyToProto(res);
        }
        return res;
    }
    static register(enumSrc, name) {
        Reflect.defineMetadata(ENUM_METADATA_KEY, new EnumDescriptor(enumSrc, name), enumSrc);
    }
    static load(enumSrc) {
        return Reflect.getOwnMetadata(ENUM_METADATA_KEY, enumSrc);
    }
}
const registerEnum = EnumDescriptor.register;
export { EnumDescriptor, registerEnum };
//# sourceMappingURL=index.js.map